import { cloneDeep, compact } from 'lodash';
import { collectAllMessageTextsInElement } from 'services/MessageTranslationsStore';

const MAX_READABLE_LENGTH = 75;

export const getTreePath = bubbleTree =>
    compact(bubbleTree.map(({ displayName }) => displayName))
        .reverse()
        .join('->');

// tooltip provider skip is intended to avoid everything to be clickable
const isClickRelevant = target =>
    (target.role === 'button' ||
        target.tagName.toLowerCase() === 'button' ||
        target.tagName.toLowerCase() === 'a' ||
        (!!target.onclick && target?.contentEditable !== 'true')) &&
    !`${target.selector}`.includes('DIV#tooltip-portal');

const getEventCoreData = ({ id, value, innerText, ariaLabel, englishText, messageIds }) => ({
    id: id || undefined,
    value: englishText || value,
    displayText: englishText || innerText || ariaLabel,
    messageIds,
});

export const transformClickEvent = event => {
    const bubbleTree = cloneDeep(event.bubbleTree);
    const clickTarget = bubbleTree.find(isClickRelevant);
    const { englishText, messageIds } = collectAllMessageTextsInElement(clickTarget, true);
    const transformedEvent = getEventCoreData({ ...event, englishText, messageIds });

    if (!clickTarget) {
        return;
    }

    bubbleTree.forEach(target => {
        if (isClickRelevant(target)) {
            target.displayName = target.displayName || target.textContent.slice(0, MAX_READABLE_LENGTH);
        }
    });

    transformedEvent.uiComponentPath = getTreePath(bubbleTree);
    transformedEvent.value = transformedEvent.value?.slice(0, MAX_READABLE_LENGTH);

    return transformedEvent;
};

export const transformChangeEvent = (event, skipCondition) => {
    const transformedEvent = getEventCoreData(event);
    const bubbleTree = cloneDeep(event.bubbleTree);
    const target = bubbleTree[0];

    if (skipCondition && skipCondition(target)) {
        return;
    }

    transformedEvent.uiComponentPath = getTreePath(bubbleTree);
    transformedEvent.value = event.value || event.textContent;

    return transformedEvent;
};

export const transformHoverEvent = event => {
    const { englishText, messageIds } = collectAllMessageTextsInElement(event);
    const transformedEvent = getEventCoreData({ ...event, englishText, messageIds });
    const bubbleTree = cloneDeep(event.bubbleTree);

    if (!event.onhover) {
        return;
    }

    transformedEvent.uiComponentPath = getTreePath(bubbleTree);

    return transformedEvent;
};

export const transformIntersectionEvent = event => {
    const { englishText, messageIds } = collectAllMessageTextsInElement(event);
    const transformedEvent = getEventCoreData({ ...event, englishText, messageIds });
    const bubbleTree = cloneDeep(event.bubbleTree);

    transformedEvent.uiComponentPath = getTreePath(bubbleTree);

    return transformedEvent;
};
